export const TAB_MAPS = {
  SUB_ACCOUNT: "SUB_ACCOUNT",
  API_KEY: "API_KEY",
};

export const APPLY_STATUS_MAPS = {
  NOT_APPLY: "NOT_APPLY", // 这有这个才可以申请
  SUCCESS: "SUCCESS",
  DENIED: "DENIED",
  PENDING: "PENDING",
};
